export default __webpack_public_path__ + "static/media/customer_ob.52ab4d32.svg";